






import { Component, Vue, Model, Emit } from 'vue-property-decorator';
import SearchPaginationTable from '@/components/search-pagination-table.vue';
import Dialog from '@/components/dialog.vue';
import DialogTable from '@/components/dialog-table.vue';
import { AgentType } from './types.d';
import moment from 'moment';
import { post } from '@/unite/api';
@Component({
  components: { SearchPaginationTable, Dialog, DialogTable }
})
export default class AvailbleDomainList extends Vue {
  created() {
    // console.log(this.api.get('/api/apply/list', this.pageData.info))
  }
  visible: boolean = false;
  visibleTable: boolean = false;
  visiblePassword: boolean = false;
  child_account: string = '';
  optionTitle: any; // 弹窗标题
  isDialog: boolean = false;
  formList: any;
  rules: any;
  pageData: any = {
    url: `/v1/config/domain`,
    isSearch: true, // 是否需要搜索框
    isPagination: true, // 是否后端分页
    isBtn: true, // 是否需要头部操作按钮
    info: {
      app_id: '',
      enable: -1,
      is_app_domain: -1,
      pagination: {
        page: 1,
        page_size: 10
      }
    }, // 传后端数据
    searchData: [
      {
        type: 'input', // text框
        model: 'app_id', // 字段
        tip: '应用id',
        msg: '请输入应用id'
      },
      {
        type: 'select',
        tip: '是否启用',
        model: 'enable',
        placeholder: '请选择是否启用',
        data: [
          {
            value: -1,
            label: '所有'
          },
          {
            value: 1,
            label: '启用'
          },
          {
            value: 0,
            label: '未启用'
          }
        ]
      },
      {
        type: 'select',
        tip: '是否app域名',
        model: 'is_app_domain',
        placeholder: '请选择是否app域名',
        data: [
          {
            value: -1,
            label: '所有'
          },
          {
            value: 1,
            label: '是'
          },
          {
            value: 0,
            label: '否'
          }
        ]
      }
    ],
    btnData: [
      {
        name: '刷新列表',
        methods: 'refesh',
        type: 'success',
        loading: false
      },
      {
        name: '添加域名',
        methods: 'add',
        type: 'primary',
        loading: false
      }
    ],
    tableData: {
      stripe: true,
      border: true,
      expandShow: false,
      optionShow: true,
      header: [
        {
          prop: 'id',
          label: 'ID'
        },
        {
          prop: 'app_id',
          label: 'appID'
        },
        {
          prop: 'domain',
          label: '可用域名'
        },
        {
          prop: 'order_num',
          label: '优先级'
        },
        {
          prop: 'isAppDomain',
          _prop: 'is_app_domain',
          label: '是否APP域名',
          color: 'is_app_domain',
          type: 'tag',
          status: {
            true: '是',
            false: '否'
          }
        },
        {
          prop: 'Cn',
          _prop: 'cn',
          label: '是否中国区域名',
          color: 'cn',
          type: 'tag',
          status: {
            true: '是',
            false: '否'
          }
        },
        {
          prop: 'Enable',
          _prop: 'enable',
          label: '是否开启',
          type: 'tag',
          color: 'enable',
          status: {
            true: '是',
            false: '否'
          }
        }
      ],
      expand: [
        {
          label: '登录IP',
          value: 'login_ip'
        },
        {
          value: 'remark',
          label: '备注'
        },
        {
          value: 'expire_time',
          label: '密码过期时间',
          type: 'time'
        }
      ],
      optionWidth: 80,
      option: [
        {
          name: '修改',
          methods: 'updata',
          type: 'text'
        }
      ]
    } // table
  };
  dialogData: any = {
    optionTitle: '添加域名',
    modifyForm: {
      url: '/v1/config/domain/create',
      type: 'post',
      form: {
        domain: '',
        order_num: '',
        app_id: '',
        is_app_domain: false,
        cn: true,
        enable: true
      },
      showData: [],
      data: [
        {
          type: 'input',
          model: 'domain',
          name: '域名',
          disabled: false,
          class: 'half'
        },
        {
          type: 'input',
          model: 'app_id',
          name: 'APPID',
          disabled: false,
          class: 'half'
        },
        {
          type: 'input',
          model: 'order_num',
          name: '优先级',
          disabled: false,
          class: 'half'
        },
        {
          type: 'switch',
          model: 'is_app_domain',
          name: '是否APP域名',
          disabled: false,
          class: 'half'
        },
        {
          type: 'switch',
          model: 'cn',
          name: '是否中国区域名',
          disabled: false,
          class: 'half'
        },
        {
          type: 'switch',
          model: 'enable',
          name: '是否启用',
          disabled: false,
          class: 'half'
        }
      ],
      formLabelWidth: '100px',
      select: {
        appType: []
      }
    },
    rules: {
      domain: [
        {
          required: true,
          message: '请输入域名',
          trigger: 'blur'
        }
      ],
      order_num: [
        {
          required: true,
          message: '请输入优先级',
          trigger: 'blur'
        }
      ]
    }
  };
  private btnClick(methods: string) {
    if (methods === 'add') {
      this.visible = true;
      this.dialogData.optionTitle = '添加域名';
      this.dialogData.modifyForm.type = 'post';
      this.dialogData.modifyForm.form = {
        domain: '',
        order_num: '',
        app_id: '',
        is_app_domain: false,
        cn: true,
        enable: true
      };
    } else {
      // @ts-ignore
      this.$refs.table.getData();
    }
  }
  private handleClick(methods: string, row: any) {
    if (methods === 'updata') {
      this.visible = true;
      this.dialogData.optionTitle = `修改域名${row.id}`;
      this.dialogData.modifyForm.url = '/v1/config/domain';
      this.dialogData.modifyForm.type = 'put';
      this.dialogData.modifyForm.form = {
        id: row.id,
        domain: row.domain,
        order_num: row.order_num,
        app_id: row.app_id,
        is_app_domain: row.is_app_domain,
        cn: row.cn,
        enable: row.enable
      };
    }
  }
  // 刷新列表
  refesh(bool: boolean) {
    if (bool) {
      // @ts-ignore
      this.$refs.table.getData();
    }
    this.visible = false;
  }
}
